<template>
  <div>
    <h3>My Students</h3>

    <b-alert variant="info" dismissible fade show>
      The students listed here are associated with you in one of the following ways:
      <ul>
        <li>The student is in an academic program that you are associated with</li>
        <li>The student has taken a pre-internship or internship course that you are associated with</li>
      </ul>
    </b-alert>
    
    <div v-if="students">
      <student-list :students="students"></student-list>
      <div v-if="!students.length">No students were found</div>
    </div>
  </div>  
</template>

<script>
import StudentList from "../../components/students/student-list";
import Widget from "../../components/widget";
import studentApi from "../../api/student";
import { mapState } from "vuex";

export default {
  data() {
    return {
      students: null
    };
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  props: {},

  components: {
    "student-list": StudentList,
    widget: Widget
  },

  methods: {},

  created() {
    var that = this;
    studentApi
      .getStudentsForAdvisor(this.user.userId)
      .then(function(response) {
        that.students = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>

<style scoped>
label {
  font-weight: bold;
}

p {
  margin-bottom: 0.3em;
}

.student-details {
  padding: 15px 5px 10px 5px;
}

.main-container {
  max-width: 100%;
  margin-top: 10px;
}

.widget-body {
  max-width: 100%;
}
</style>
